
import ILessonModule from "../typings/ILessonModule";
import { IStudentLesson } from "../typings/Lesson";
import http from "./client";

interface ILessonModulesGetParams {
  course_id: string | number;
  withLessonsCount?: boolean;
  search?: string;
  withSettings?: boolean;
  withChats?: boolean;
}

export async function authorList(params: ILessonModulesGetParams): Promise<Array<ILessonModule>> {
  const resp = await http.get('/api/lesson-module/author-list', {
    params: params
  });
  return resp.data.data;
};

export async function studentList(params: ILessonModulesGetParams): Promise<Array<ILessonModule<IStudentLesson>>> {
  const resp = await http.get('/api/lesson-module/student-list', {
    params: params
  });
  return resp.data.data;
};

export async function save(item: Partial<Omit<ILessonModule, 'lessons'>>, courseId: string | number) {
  const response = await http.post('/api/lesson-module/save', item, {
    params: {
      course_id: courseId,
    }
  });

  return response.data.data;
};

export async function copy(moduleId: string | number, courseId: string | number) {
  const response = await http.post('/api/lesson-module/copy', {
   id: moduleId,
   course_id: courseId
  });

  return response.data.data;
};

export async function remove(moduleId: string | number, courseId: string | number) {
  const response = await http.post('/api/lesson-module/delete', {
    id: moduleId,
    course_id: courseId
  });
  return response.data;
};

export async function createChat(moduleId: string | number, courseId: string | number) {
  // https://at-local.1iu.ru/panel/messages?course_id=3&to_room_id=215
  const response = await http.post('/api/lesson-module/chat', {
    id: moduleId,
    course_id: courseId
  });
  return response.data;
}


const lessonModule = {
  authorList, studentList, save, copy, remove, createChat
}

export default lessonModule;